import PrivacyContent from "./PrivacyContent";
import TermsOfUse from "./TermsOfUse";
import "./PopUpModel.css";

export default function PopUpModel({ showModal, setShowModal, modalType }) {
  if (!showModal) return null;

  return (
    <div
      className="modal-overlay"
      onClick={() => setShowModal(false)}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="close-btn"
          onClick={() => setShowModal(false)}
        >
          X
        </button>
        <div className="modal-body">
          {modalType === "terms" ? (
            <TermsOfUse />
          ) : (
            <PrivacyContent />
          )}
        </div>
      </div>
    </div>
  );
}
